import styled from 'styled-components';

export const Keybox = styled.div`
  border-radius: 5px;
  border: none;
  display: flex;
  position: relative;
  height: ${({$height}) => $height || "46px"};
  overflow: hidden;
  width: 100%;
  margin-bottom: ${(props) =>
    props.$marginBottom ? props.$marginBottom : "15px"};

  @media screen and (max-width: 767px) {
    height: ${(props) => props.$heightMobile || props.$height || "46px"};
  }
`;

export const Input = styled.input`
    //width: 100%;
    width: calc(100% - 40px) !important;
    font-family: "Mulish", sans-serif;
    padding-right: 60px;
    padding-left: 18px;
    font-size: 14px;
    height: 100%;
    border: ${({ disabled, $activeButton }) =>
            disabled ?? !$activeButton
                    ? `1px solid var(--disabled-c)`
                    : `1px solid var(--blue)`};
    border-radius: 0 5px 5px 0;
    border-left-style: none;

    &::placeholder {
      color: var(--roman-silver);
      display: inline;
        font-size: 14px;
        font-family: "Mulish", sans-serif;
    }
;


    ${(props) =>
            props.disabled &&
            `
    &&::placeholder {
      color: var(--disabled-c);
    }
  `};

    @media screen and (max-width: 767px) {
        font-size: 12px;
        height: auto !important;
        &&::placeholder {
            font-size: 12px;
        }
    }
`;

export const RedFile = styled.u`
    &:hover {
        cursor: pointer;
    }

    color: red;
    margin-left: auto;
`;

export const KeyboxLabel = styled.label`
  position: relative;
  background-color: var(--black);
  display: block;
  height: 100%;
  width: 46px;
  
  ${(props) => (props.error ? `background-color: var(--red)` : undefined)};

    ${(props) => (props.error ? `background-color: var(--red)` : undefined)};

    @media screen and (max-width: 767px) {

        width: ${(props) => props.$heightMobile || '40px'};
    };
}
`;

export const VisibilityStyles = styled.button`
    position: absolute;
    color: var(--black);
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1px;
    cursor: pointer;
    width: 44px;
    height: 100%;

    ${({ disabled }) =>
            disabled ? `color: var(--disabled-c)` : `color: var(--black)`};
`;
